import api from "./api";
import UserService from "./user.service";
import { isAdmin } from "src/Common/function";

const create = (data) => {
  return api.post("/api/customer-user-invite/create", data);
};

const accept = (data) => {
  return api.get("/api/invite/accept", { params: data });
};

const getAll = (customerId) => {
  return api.get("/api/customer-user-invite/get-all", { params: { customerId } });
};

const getPendingAll = () => {
  return api.get("/api/customer-user-invite/get-pending-all");
};

const deleteInvite = (id) => {
  return api.delete(`/api/customer-user-invite/${id}`);
};

const repeatInvite = (id) => {
  return api.post(`/api/customer-user-invite/repeat/${id}`);
};

const CustomerInviteService = {
  create,
  accept,
  getAll,
  getPendingAll,
  deleteInvite,
  repeatInvite,
};

export default CustomerInviteService;
